import {
  ProductSelections,
  FetchProductSelectionsAction,
  FetchProductSelectionsSuccessAction,
  FetchProductSelectionsFailAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function fetchProductSelections(applicationId: string): FetchProductSelectionsAction {
  return { type: REDUX_STORE.PRODUCT_SELECTIONS.ACTION_TYPES.FETCH_PRODUCT_SELECTIONS, applicationId };
}

export function fetchProductSelectionsSuccess(
  productSelections: ProductSelections
): FetchProductSelectionsSuccessAction {
  return {
    type: REDUX_STORE.PRODUCT_SELECTIONS.ACTION_TYPES.FETCH_PRODUCT_SELECTIONS_SUCCESS,
    productSelections,
  };
}

export function fetchProductSelectionsFail(message: string): FetchProductSelectionsFailAction {
  return { type: REDUX_STORE.PRODUCT_SELECTIONS.ACTION_TYPES.FETCH_PRODUCT_SELECTIONS_FAIL, message };
}
